export default __webpack_public_path__ + "static/media/03-BB-(03-2).32a55022.jpg";